import React, { useState } from "react";
import { Box, Paper, Tabs, Tab, TextField, Button, Typography, Alert, Container } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const AuthPage = () => {
    const [tabIndex, setTabIndex] = useState(0); // 0: Employee, 1: Admin
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        setError(null);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);
        try {
            const role = tabIndex === 1 ? 'admin' : 'employee';
            await login(role, email, password);
            
            // Redirect
            const from = location.state?.from?.pathname;
            if (from) {
                navigate(from, { replace: true });
            } else {
                if (role === 'admin') navigate('/admin/booking-management');
                else navigate('/employee/time-management');
            }
        } catch (err) {
            setError(err.message || "Login failed");
        }
    };

    return (
        <React.Fragment>
            <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', bgcolor: '#f5f5f5' }}>
                <Paper elevation={3} sx={{ p: 4, width: '100%', borderRadius: 2 }}>
                    <Tabs value={tabIndex} onChange={handleTabChange} centered sx={{ mb: 3 }}>
                        <Tab label="Employee Login" />
                        <Tab label="Admin Login" />
                    </Tabs>

                    <Typography variant="h5" align="center" gutterBottom color="primary">
                        {tabIndex === 1 ? "Admin Login" : "Employee Login"}
                    </Typography>

                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                    <form onSubmit={handleLogin}>
                        <TextField
                            label="Email"
                            fullWidth
                            margin="normal"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="off"
                        />
                        <TextField
                            label="Password"
                            type="password"
                            fullWidth
                            margin="normal"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                        />

                        <Button 
                            type="submit" 
                            variant="contained" 
                            fullWidth 
                            size="large" 
                            sx={{ mt: 3, mb: 2 }}
                        >
                            LOGIN
                        </Button>
                    </form>
                    
                    <Box sx={{ mt: 2, textAlign: 'center' }}>
                        <Typography variant="caption" color="text.secondary">
                            (Demo: {tabIndex === 1 ? "admin@company.com / admin123" : "john.smith@company.com / password123"})
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </React.Fragment>
    );
};

export default AuthPage;
